/**
 * Ivan 参数设置列表页共用：行选中、只读操作提示、客户端分页。
 */
export default {
  data() {
    return {
      selectedId: null,
      pageIndex: 0
    }
  },
  methods: {
    onReadonly() {
      this.$message.info('当前为 Ivan 同步只读对照，暂不支持增删改')
    },
    selectRow(id) {
      this.selectedId = id
    },
    resetPage() {
      this.pageIndex = 0
      this.selectedId = null
    },
    pageSlice(list, pageSize) {
      const size = pageSize || 15
      const start = this.pageIndex * size
      return (list || []).slice(start, start + size)
    },
    calcPageCount(total, pageSize) {
      return Math.max(1, Math.ceil((total || 0) / (pageSize || 15)))
    }
  }
}
